var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.mobileDevice === 'mobileDevice')?_c('MobileCallBack'):_vm._e(),(_vm.mobileDevice === 'pcDevice')?_c('PcCallBack'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }